var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlibabaCloud = function SvgAlibabaCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.5 37.28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".alibaba-cloud_svg__cls-1{fill:#ff6a00}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "alibaba-cloud_svg__cls-1",
    d: "M19.94 16.3h19.92v4.49H19.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "alibaba-cloud_svg__cls-1",
    d: "M49.84 0H36.66l3.18 4.5 9.61 3a4.15 4.15 0 0 1 2.9 4v14.34a4.17 4.17 0 0 1-2.9 4l-9.61 2.94-3.18 4.5h13.18a9.94 9.94 0 0 0 9.95-10V10a10 10 0 0 0-9.95-10ZM10 0h13.14L20 4.5l-9.61 3a4.16 4.16 0 0 0-2.91 4v14.34a4.18 4.18 0 0 0 2.91 4L20 32.78l3.18 4.5H10a10 10 0 0 1-10-10V10A10 10 0 0 1 10 0Z"
  })));
};
export { SvgAlibabaCloud as ReactComponent };
export default __webpack_public_path__ + "img/alibaba-cloud.c95ce7a96fac3ed51e9c263336ad9747.svg";